import React, {Component} from 'react';
import PropTypes from 'prop-types';

import RiderLogo from '../lib/RiderLogo';
import Loading from '../lib/Loading';
import AppLayout from '../lib/AppLayout';
import apiService from '../lib/apiService';
import Failed from '../lib/Failed';
import Welcome from './Welcome';
import validateLength from '../lib/validateLength';

const validateEighth = validateLength(8);
const validateOne = validateLength(1);

export default class Registration extends Component {
  constructor(props, context) {
    super(props, context);

    ['onSubmit', 'onChange'].forEach(fn => this[fn] = this[fn].bind(this));

    this.state = {
      isLoading: true,
      passwordValid: true,
      nameValid: true
    };

    const invitationId = props.params.uuid;

    apiService(
      `/invitations/${invitationId}/`,
      'GET'
    )
    .then(({ok}) => ok)
    .then(ok => {
      this.setState({
        isLoading: false,
        invitationError: !ok
      })
    })
  }

  validate() {
    const {fullName, password} = this.state;

    const nameValid = validateOne(fullName);
    const passwordValid = validateEighth(password);

    let newState = {
      nameValid,
      passwordValid
    };

    this.setState(newState);

    return nameValid && passwordValid;
  }

  onChange({target}) {
    this.setState({[target.id]: target.value});
  }

  onSubmit(e) {
    e.preventDefault();

    const {fullName, password} = this.state;

    const {query, params} = this.props;
    const [firstName, ...lastName] = fullName ? fullName.split(' ') : [];

    const isValidInput = this.validate();

    if (!isValidInput) {
      return;
    }

    this.setState({
      isLoading: true
    });

    apiService('/registration/', 'POST', {
      email: query.email,
      'invitation_uuid': params.uuid,
      'first_name': firstName,
      'last_name': lastName.join(' '),
      password
    })
    .then(({ok}) => {
      window.setTimeout(() => {
        this.setState({
          isLoading: false,
          success: ok
        });
        // we redirect user to /success page so that in case user
        // has successfully registered and refreshes the page
        // they don’t see "invite is used" error
        if (ok) {
          this.context.history.replace('/invitation/success');
        }
      }, 500);
    });
  }

  render() {
    const {query, params: {uuid}} = this.props;
    const {
      nameValid,
      passwordValid,
      success,
      isLoading,
      invitationError
    } = this.state;

    if (success && uuid === 'success') {
      return <Welcome />
    }

    const content = <div className='App-Card'>
      <RiderLogo />
      <h1 className='App-Card-title'>{
       'You have been invited to Noa Rider'
      }</h1>
      <p className='App-Card-message'>{
       'Please finish the registration by entering your name and ' +
       'a secure password to start using Noa Rider.'
      }</p>
      <form onSubmit={this.onSubmit}>
       <input
         className='App-input'
         value={query.email}
         id='email'
       />
       <input
         className={
           `App-input ${nameValid ? '' : 'App-input-error'}`
         }
         placeholder='Full Name (required)'
         id='fullName'
         onChange={this.onChange}
       />
       <input
         className={
           `App-input ${passwordValid ? '' : 'App-input-error'}`
         }
         type='password'
         id='password'
         placeholder='Password (required)'
         onChange={this.onChange}
       />
       <p className={
         `App-input-comment ${passwordValid ? '' : 'App-input-error'
         }`
       }>
         {'At least 8 characters'}
       </p>
       <button
         className='App-Card-button'
         type='submit'
       >
         {'Signup'}
       </button>
      </form>
    </div>

    if (isLoading) {
      return <AppLayout>
        <Loading />
      </AppLayout>
    }

    if (invitationError) {
      return <AppLayout>
        <Failed
          title={
            'Loading invitation failed'
          }
          message={
            'Sorry, we can’t find this invitation. Maybe it was already accepted ' +
            'or something is wrong with the link you followed. If you still need ' +
            'help, please contact support'
          }
        />
      </AppLayout>
    }

    return <AppLayout>{content}</AppLayout>;
  }
}

Registration.contextTypes = {
  history: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/views/Registration.js